import Button from "components/Button";
import React from "react";
import { buildingStore } from "store/Building/BuildingStore";
import EmptyState from "components/EmptyState";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ROUTES_ENUM } from "routes/consts";

const useDashboards = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const openOperationalEmissions = () => {
    navigate(
      `/${ROUTES_ENUM.BUILDINGS}/${buildingStore.currentBuilding?.id}/${ROUTES_ENUM.OPERATIONAL_ENERGY}`
    );
  };

  function showEmptyState(className?: string) {
    if (buildingStore.buildingHasKeineCertification())
      return (
        <EmptyState
          type="data"
          containerClassName="bg-transparent !p-0"
          iconClassName={className}
          noBorder
          titleClassName="text-xs max-w-5xl font-medium"
          title={t("dashboard.keineCertificationChartInfo")}
          hideMEButton
        />
      );

    return (
      <EmptyState
        type="data"
        containerClassName="bg-transparent !p-0"
        noBorder
        titleClassName="text-xs font-medium"
        title={t("dashboard.noOperationalEmissionsChartInfo")}
        iconClassName={className}
        button={
          <Button
            type="secondary"
            width="fit-content"
            className="mt-3.5 !h-[35px]"
            onClick={openOperationalEmissions}
          >
            {t("dashboard.addOperationalEmissions")}
          </Button>
        }
      />
    );
  }

  return {
    showEmptyState,
    openOperationalEmissions,
  };
};

export default useDashboards;
